import React from 'react';
import { ApButtonLink } from '@alixpartners/ui-components';

import {
  ContentBlock,
  CostValue,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../BuildReports.styles';

interface IQuickViewSectionProps {
  powerBiWorkspaceUrl: string;
}
export const QuickViewSection = ({
  powerBiWorkspaceUrl,
}: IQuickViewSectionProps) => {
  return (
    <SectionWrapper animationIndex={2}>
      <Title>Quick view and edit using Power BI Online</Title>
      <ContentBlock>
        <Description>
          Power BI Desktop includes the fullest feature set but you can also
          quickly view and edit reports using Power BI online.
        </Description>
        <RightSection>
          <RightSectionColumn>
            <CostValue>
              <ApButtonLink
                target="_blank"
                href={powerBiWorkspaceUrl}
                rel="noopener noreferrer"
              >
                Open Power BI Workspace
              </ApButtonLink>
            </CostValue>
          </RightSectionColumn>
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
